module.exports = __webpack_public_path__ + "assets/media/brian_moseley.ad727ab1.svg";